import { withInstall } from '@tw-element/utils'

import Scrollbar from './src/scrollbar.vue'

export const TwScrollbar = withInstall(Scrollbar)
export default TwScrollbar

export * from './src/util'
export * from './src/scrollbar'
export * from './src/thumb'
